import React from 'react'
import { Container } from 'react-bootstrap'
import Button from 'react-bootstrap/button';
import { Link, useLocation, useParams } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';
import Footer from '../Footer/Footer';


const Alojamientoweb = () => {
  const location = useLocation();

  // Verificar si la ruta actual es diferente de /Servicios
  const mostrarBoton = location.pathname !== '/Servicios';
  const mostrarSeparador = location.pathname !== '/Servicios';
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  
const {nombre} = useParams();


  return (
    <>
  
    {mostrarSeparador && (
        <div className='separador'>
          <h3 className='colorini titulo-servicio'>
            <TypeAnimation
              sequence={[
                "Servicio: PORTFOLIO WEB.",500,
              ]} 
              repeat={0}
              style={{ fontSize: '1.5em' }}
            />
          </h3>
        </div>
      )}
  

<Container >
    <div className='div-desarrollo' data-aos="fade-up">
      <h3 className='titulo-servicio' style={ { color:"White",}}>ALOJAMIENTO WEB</h3>{/* titulo */}
  <br></br>
      <h4 className='subtitulo-servicio' style={ { color:"White",}}>¡Desata el potencial de tu presencia en línea con nuestro alojamiento web en Hostinger!</h4>{/* titulo */}
      <br></br>
      <p className="parrafo-servicio" style={ { color:"White",}}>En NinnoTech, te ofrecemos servicios de alojamiento web potentes y asequibles con Hostinger. Con nuestra plataforma, podrás alojar tu sitio web en un entorno seguro y de alto rendimiento, respaldado por la infraestructura líder en la industria de Hostinger. Además, te brindamos la flexibilidad de registrar y utilizar tu propio dominio personalizado, lo que te permite crear una presencia en línea única y memorable para tu proyecto o negocio. Con nuestro alojamiento web en Hostinger, tienes todo lo que necesitas para llevar tu sitio web al siguiente nivel. ¡Únete a NinnoTech y haz que tu presencia en línea despegue hoy mismo!</p>
  

      <a href='https://wa.me/2235985787' target='_blank'><Button className='btn-servicios'>Pedir Cotizacion</Button></a>
    {mostrarBoton && (
      <Link to="/Servicios">
        <Button className='btn-servicios' style={{ marginLeft: "42.5%" }} onClick={handleScrollToTop}>Volver a Servicios</Button>
      </Link>
    ) }

    </div>

    

    </Container>  
    {mostrarSeparador && (
      <div className='separador-f'>
      <Footer/>
      </div> 
    )}
    </>
    )
}

export default Alojamientoweb